import getJobTypeMessages from './getJobTypeMessages';

import type { LocaleMessages } from 'shared-types';
import type { GetJobsStatusRes } from 'shared-types/responses';
import type { PendingJobEntry } from 'types';

/**
 * Builds the pendingJobs slice payload from a cold-start status response,
 * filling each entry with generic per-type copy.
 */
const buildPendingJobsFromStatus = (
  statusJobs: GetJobsStatusRes['jobs'],
  messages: LocaleMessages
) => {
  const pendingJobs: Record<number, PendingJobEntry> = {};

  Object.values(statusJobs).forEach((job) => {
    pendingJobs[job.id] = {
      messages: getJobTypeMessages(messages, job.type),
      type: job.type
    };
  });

  return pendingJobs;
};

export default buildPendingJobsFromStatus;
